<template>
	<div 
		v-show="visibles" 
		class="full-container">
		<slide-view 
			v-show="showDetail" 
			:show-close="false" 
			:no-listener-class="['bell-message-hook']" 
			class="d-view"
			@close="hiddenView">
			<div class="sm-main">
				<div class="sm-main__hd">
					<span class="title">{{ title }}</span>
				</div>
				<flexbox class="menu" wrap="wrap">
					<el-badge 
						v-for="(item, index) in menuList" 
						:key="index" 
						:value="unreadNums[item.countKey]"
						:hidden="!unreadNums[item.countKey] || unreadNums[item.countKey] == 0" 
						:max="99">
						<el-button 
							:class="{'is-current': menuLabel == item.label}" 
							type="warning"
							@click.native="menuClick(item.label)">{{ item.name }}</el-button>
					</el-badge>
				</flexbox>
				<div :style="{ height: contentHeight }" class="sm-main__bd">
					<div 
						v-infinite-scroll="getList" 
						:key="scrollKey" 
						infinite-scroll-distance="100"
						infinite-scroll-disabled="scrollDisabled">
						<message-cell 
							v-for="(item, index) in list" 
							:key="index" 
							:data="item" 
							:data-index="index"
							@detail="checkCRMDetail" 
							@download="downloadError" 
							@read="readMessageClick"
							@delete="deleteMessageClick" />
					</div>
					<p v-if="loading" class="scroll-bottom-tips">加载中...</p>
					<p v-if="noMore" class="scroll-bottom-tips">没有更多了</p>
				</div>
				<flexbox class="sm-main__ft">
					<div class="switch-read">
						<el-switch v-model="isUnRead" @change="refreshList" />
						<span class="switch-read__title">仅显示未读消息</span>
					</div>
					<el-dropdown trigger="click" @command="handleCommand">
						<i class="el-icon-more more" />
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item icon="el-icon-check" command="read">
								{{ `全部${currentMenu.label == 'all' ? '' : currentMenu.name}标记为已读` }}
							</el-dropdown-item>
							<el-dropdown-item icon="wk wk-s-delete" command="delete">
								{{ `删除${currentMenu.name}已读消息` }}
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</flexbox>
			</div>
		</slide-view>
		
	</div>
</template>
<script>
	import SlideView from '@/components/FromData/SlideView'
	import { getMaxIndex } from '@/utils/index'
	import MessageCell from './MessageCell'
	import { mapGetters } from 'vuex'
	import { 
		systemMessageListAPI,
		systemMessageReadAllAPI,
		systemMessageReadAPI,
		systemMessageDeleteByIdAPI,
		systemMessageClearAPI ,
	} from '@/api/common'
	export default {
		name: 'SystemMessage',
		data() {
			return {
				showDetail: false,
				menuLabel: 'all',
				scrollKey: Date.now(),
				
				// 列表
				list: [],
				loading: false,
				noMore: false,
				page: 1,
				isUnRead: false, // 仅展示未读
				// 详情
				showDview:false,
				rowType:'',
				rowID:0
			}
		},
		components: {
			SlideView,
			MessageCell
		},
		props: {
			visibles: {
				type: Boolean,
				default: false
			},
			unreadNums: Object
		},
		computed: {
			...mapGetters(['allAuth']),
			title() {
				return this.unreadNums.allCount > 0 ? `通知（${this.unreadNums.allCount}）` : '通知'
			},
			menuList() {
				const menuList = [{
					name: '全部',
					label: 'all',
					countKey: 'allCount'
				}]
				menuList.push({
					name: '客户',
					label: 1,
					countKey: 'customer'
				},{
					name: '案件',
					label: 2,
					countKey: 'lawcase'
				},{
					name: '顾问',
					label: 3,
					countKey: 'contract'
				},{
					name: '财务',
					label: 4,
					countKey: 'finance'
				})
				return menuList
			},
			contentHeight() {
				if (this.menuList.length > 7) {
					return 'calc(100% - 110px)'
				}
				return 'calc(100% - 155px)'
			},
			scrollDisabled() {
				return this.loading || this.noMore
			},
			labelValue() {
				return this.menuLabel == 'all' ? '' : this.menuLabel
			},
			currentMenu() {
				return this.menuList.find(item => {
					return item.label === this.menuLabel
				})
			}
		},
		watch: {
			visibles: {
				handler(val) {
					this.showDetail = val
					if (val) {
						this.$el.style.zIndex = getMaxIndex()
						this.refreshList()
					}
				},
				immediate: true
			},
			showDetail(val) {
				if (!val) {
					setTimeout(() => {
						this.$emit('update:visibles', false)
					}, 350)
				}
			}
		},
		mounted() {
			document.body.appendChild(this.$el)
			this.$el.addEventListener('click', this.handleDocumentClick, false)
		},
		beforeDestroy() {
			// remove DOM node after destroy
			if (this.$el && this.$el.parentNode) {
				this.$el.parentNode.removeChild(this.$el)
				this.$el.removeEventListener('click', this.handleDocumentClick, false)
			}
		},
		methods: {
			hiddenView() {
				this.showDetail = false
			},

			/**
			 * 菜单点击
			 */
			menuClick(label) {
				this.menuLabel = label
				this.refreshList()
			},

			/**
			 * 获取列表
			 */
			getList() {
				this.loading = true
				const params = {
					page: this.page,
					limit: 15,
					label: this.labelValue
				}
				if (this.isUnRead) {
					params.is_read = 0
				}
				systemMessageListAPI(params)
					.then(res => {
						this.loading = false
						if (this.labelValue == params.label) {
							if (!this.noMore) {
								if (this.page == 1) {
									this.list = res.data.page.list
								} else {
									this.list = this.list.concat(res.data.page.list)
								}
								this.page++
							}
							this.noMore = res.data.page.lastPage
						} else {
							this.refreshList()
						}
					})
					.catch(() => {
						this.noMore = true
						this.loading = false
					})
			},

			handleDocumentClick(e) {
				e.stopPropagation()
				if (this.$el == e.target) {
					this.showDetail = false
				}
			},
			
			/**
			 * 查看详情
			 */
			checkCRMDetail(type, id, dataIndex, data) {
				
				if(data.controller_name == "customer"){
					this.$router.push({
						path:"/customer/read/basicinfo/"+id
					})
				}else if(data.controller_name == "lawcase"){
					this.$router.push({
						path:"/lawcase/read/basicinfo/"+id
					})
				}else if(data.controller_name == "contract"){
					this.$router.push({
						path:"/contract/read/basicinfo/"+id
					})
				}
			},
			
			/**
			 * 下载错误数据
			 */
			downloadError(data) {},
			
			/**
			 * 读取消息
			 */
			readMessageClick(messageId, index) {
				systemMessageReadAPI({
				    id: messageId
				})
				.then(res => {
				    this.list[index].is_read = 1
				    this.$emit('update-count')
				})
				.catch(() => {})
			},
			
			/**
			 * 删除消息
			 */
			deleteMessageClick(messageId, index) {
				this.$confirm('确定删除这条消息?', '提示', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				  })
				  .then(() => {
				    systemMessageDeleteByIdAPI({
				        id: messageId
				      })
				      .then(res => {
				        this.list.splice(index, 1)
				        this.$emit('update-count')
				        this.$message.success('操作成功')
				      })
				      .catch(() => {})
				  })
				  .catch(() => {
				    this.$message({
				      type: 'info',
				      message: '已取消操作'
				    })
				  })
			},
			
			/**
			 * 刷新列表
			 */
			refreshList() {
				this.page = 1
				this.list = []
				this.noMore = false
				this.scrollKey = Date.now()
			},
			
			handleCommand(action) {
				if (action === 'delete') {
					this.allDeleteClick()
				} else {
					this.allMarkDoneClick()
				}
			},
			
			/**
			 * 全部删除
			 */
			allDeleteClick() {
				if (this.currentMenu) {
					const name = this.currentMenu.label == 'all' ? '' : this.currentMenu.name
					this.$confirm(`确定删除全部${name}已读消息?`, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
					.then(() => {
						systemMessageClearAPI({
							label: this.labelValue
						})
						.then(res => {
							this.refreshList()
							this.$emit('update-count')
							this.$message.success('操作成功')
						})
						.catch(() => {})
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消操作'
						})
					})
				}
			},
			
			/**
			 * 全部标记完成
			 */
			allMarkDoneClick() {
				systemMessageReadAllAPI({
					label: this.labelValue
			    })
			    .then(res => {
					this.list.forEach(item => {
						item.is_read = 1
					})
					this.$emit('update-count')
			    })
			    .catch(() => {})
			},
			
			// 详情
			handleHandle(item){}
		},
	}
</script>
<style lang="scss" scoped>
	.full-container {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		overflow: auto;
		margin: 0;
		background-color: rgba(0, 0, 0, 0.3);
	}

	.d-view {
		position: fixed;
		// width: 530px;
		top: 0px;
		bottom: 0px;
		right: 0px;
		background-color: white;

		/deep/ .el-card__body {
			height: 100%;
		}
	}

	.sm-main {
		height: 100%;
		position: relative;

		&__hd {
			padding: 0 20px;
			height: 50px;
			line-height: 50px;
			font-size: 14px;
			color: #333;
			background-color: #f7f8fa;

			.title {
				font-weight: 600;
			}

			.notice-btn {
				float: right;
				margin-top: 10px;
			}
		}

		&__bd {
			overflow-y: auto;
		}

		&__ft {
			position: absolute;
			left: 0;
			right: 0;
			bottom: -1px;
			height: 50px;
			background-color: #f7f8fa;
			padding: 0 15px;

			.switch-read {
				flex: 1;

				&__title {
					font-size: 13px;
					margin-left: 10px;
					color: #333;
				}
			}

			.more {
				flex-shrink: 0;
				cursor: pointer;
			}

			.more:hover {
				color: #2362FB;
			}
		}
	}

	// 菜单
	.menu {
		overflow-x: auto;
		overflow-y: hidden;
		padding-right: 15px;
		margin-bottom: 15px;
		// line-height: 60px;
		border-top: 1px solid #e6e6e6;
		// border-bottom: 1px solid $xr-border-color-base;

		.el-button {
			color: #666;
			margin-left: 15px;
			background-color: #F6F8FA;
			border-color: #F6F8FA;
			font-size: 12px;
			height: 28px;
			border-radius: 14px;

			/deep/ i {
				font-size: 12px;
				margin-right: 5px;
			}
		}

		.el-button--warning.is-current,
		.el-button--warning:hover {
			background: #b5060d;
			border-color: #b5060d;
			color: #ffffff;
		}

		.el-badge {
			margin-top: 15px;
		}
	}


	.scroll-bottom-tips {
		margin: 15px 0 65px;
		text-align: center;
		font-size: 12px;
		color: #666;
	}

	.el-badge {
		/deep/ .el-badge__content.is-fixed {
			z-index: 2;
		}
	}
</style>
